import Trainman from './trainman';
import Passenger from './passenger';

export { Passenger, Trainman };

export default Trainman;



// WEBPACK FOOTER //
// ./src/index.js